import { ReactElement } from 'react'
import { Restore } from '@mui/icons-material'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

type Props = Omit<LoadingButtonProps, 'startIcon'>

const RestoreLoadingButton = (props: Props): ReactElement => (
  <LoadingButton {...props} startIcon={<Restore />} />
)

export default RestoreLoadingButton
